import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MatchAnalytics {
  overview: {
    total_sent: number;
    total_received: number;
    total_active_matches: number;
    acceptance_rate: number;
    credits_spent: number;
  };
  sent_requests: {
    total: number;
    pending: number;
    accepted: number;
    rejected: number;
    expired: number;
    by_type: {
      playdate: number;
      friendship: number;
      breeding: number;
      adoption: number;
    };
  };
  received_requests: {
    total: number;
    pending: number;
    accepted: number;
    rejected: number;
    by_type: {
      playdate: number;
      friendship: number;
      breeding: number;
      adoption: number;
    };
  };
  active_matches: {
    total: number;
    with_chat: number;
    by_type: {
      playdate: number;
      friendship: number;
      breeding: number;
      adoption: number;
    };
  };
  credits: {
    total_spent: number;
    total_purchased: number;
    spent_on_matches: number;
    spent_on_super_matches: number;
  };
  timeline: Array<{
    date: string;
    sent: number;
    received: number;
    matches: number;
  }>;
}

export const useMatchAnalytics = (timeframe: '7d' | '30d' | '90d' | 'all' = '30d') => {
  const { data, isLoading, error } = useQuery<MatchAnalytics>({
    queryKey: ['match-analytics', timeframe],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('get-match-analytics', {
        body: { timeframe }
      });

      if (error) throw error;
      return data.analytics;
    },
    staleTime: 5 * 60 * 1000 // Cache por 5 minutos
  });

  return {
    analytics: data,
    isLoading,
    error
  };
};
